<ion-modal [isOpen]="preview.previewModalVisible()" (didDismiss)="close()">
  <ng-template>
    <ion-header [translucent]="true">
      <ion-toolbar>
        <ion-title>{{ preview.previewEntry()?.fileName || ('mobile.filePreview.preview' | translate) }}</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="close()" aria-label="{{ 'mobile.filePreview.close_preview' | translate }}">
            <ion-icon slot="icon-only" name="close-outline" aria-hidden="true"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content [fullscreen]="true" class="preview-content">
      <div class="preview-body">
        <div *ngIf="preview.previewLoading()" class="preview-state" role="status">
          <ion-spinner name="crescent"></ion-spinner>
          <p>{{ 'mobile.filePreview.loading' | translate }}</p>
        </div>

        <div *ngIf="!preview.previewLoading() && preview.previewError()" class="preview-state preview-state--error" role="alert">
          <ion-icon name="alert-circle-outline" aria-hidden="true"></ion-icon>
          <h2>{{ 'mobile.filePreview.unavailable' | translate }}</h2>
          <p>{{ (preview.previewError() || '') | translate }}</p>
          <ion-button fill="solid" (click)="retry()">
            {{ 'common.retry' | translate }}
          </ion-button>
          <ion-button *ngIf="preview.previewUrl()" fill="outline" (click)="openExternal()">
            <ion-icon slot="start" name="open-outline" aria-hidden="true"></ion-icon>
            {{ 'mobile.filePreview.open_in_browser' | translate }}
          </ion-button>
        </div>

        <ng-container *ngIf="!preview.previewLoading() && !preview.previewError() && preview.previewEntry() as entry">
          <div *ngIf="preview.isPreviewImageEntry(entry)" class="preview-image-wrap">
            <img class="preview-image" [src]="preview.previewUrl() || ''" [alt]="entry.fileName" />

            <div class="preview-actions">
              <ion-button fill="outline" size="small" (click)="openExternal()">
                <ion-icon slot="start" name="open-outline" aria-hidden="true"></ion-icon>
                {{ 'mobile.filePreview.open_in_browser' | translate }}
              </ion-button>
              <ion-button fill="clear" size="small" (click)="download()">
                <ion-icon slot="start" name="download-outline" aria-hidden="true"></ion-icon>
                {{ 'mobile.filePreview.download' | translate }}
              </ion-button>
            </div>
          </div>

          <div *ngIf="preview.isPreviewPdfEntry(entry)" class="preview-pdf-wrap">
            <iframe *ngIf="preview.previewPdfUrl() as pdfUrl" class="preview-pdf" [src]="pdfUrl" title="{{ 'mobile.filePreview.pdf_preview' | translate }}" (error)="preview.handlePdfRenderError()"></iframe>

            <div class="preview-actions">
              <ion-button fill="outline" size="small" (click)="openExternal()">
                <ion-icon slot="start" name="open-outline" aria-hidden="true"></ion-icon>
                {{ 'mobile.filePreview.open_in_browser' | translate }}
              </ion-button>
              <ion-button fill="clear" size="small" (click)="download()">
                <ion-icon slot="start" name="download-outline" aria-hidden="true"></ion-icon>
                {{ 'mobile.filePreview.download' | translate }}
              </ion-button>
            </div>
          </div>
        </ng-container>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
